import type { EdgeData } from '../types/EdgeData';
import type { EdgeParam } from '../types/EdgeParam';

export const isEdgeParam = (edge: EdgeData): edge is EdgeParam => !('id' in edge);
